export type FACEBOOK_POSTS_TYPES = 'POST' | 'VIDEO';

export const EmbedFacebookService = {
  getEmbedAttributes ({ href, postType }: { href: string; postType: FACEBOOK_POSTS_TYPES }): Record<string, string> {
    switch (postType) {
      case 'VIDEO':
        return {
          className: 'fb-video',
          'data-href': href,
          'data-lazy': 'true',
        };
      case 'POST':
      default:
        return {
          className: 'fb-post',
          'data-href': href,
          'data-lazy': 'true',
        };
    }
  },
  getEmbedHref ({ url }: { url: string }) {
    const facebookIframeURL = new URL(url);
    if (facebookIframeURL.searchParams.has('href')) {
      return facebookIframeURL.searchParams.get('href')!;
    } else {
      throw new Error('RTC / Embeds / Facebook: No HREF param in Facebook Iframe URL');
    }
  },
  getEmbedType ({ href }: { href: string }): FACEBOOK_POSTS_TYPES {
    switch (true) {
      case href.includes('/videos/'):
        return 'VIDEO';
      case href.includes('/posts/'):
      default:
        return 'POST';
    }
  },
};
